import { toast as sonnerToast } from 'sonner';

interface ToastOptions {
  title?: string;
  description?: string;
  variant?: 'default' | 'destructive';
  duration?: number;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export function useToast() {
  const toast = (options: ToastOptions) => {
    const { title, description, variant, duration = 5000, action } = options;

    if (variant === 'destructive') {
      sonnerToast.error(title, {
        description,
        duration,
        action: action ? {
          label: action.label,
          onClick: action.onClick,
        } : undefined,
      });
    } else {
      sonnerToast.success(title, {
        description,
        duration,
        action: action ? {
          label: action.label,
          onClick: action.onClick,
        } : undefined,
      });
    }
  };

  return { toast };
}

// Re-export sonner toast for direct use
export { toast as sonnerToast } from 'sonner';
